import React from "react";
import {Row, Col} from "antd";
import {PageContainer} from "@/components/PageContainer/PageContainer";
import MspLogo from "@/components/Footer/icons/MSP_logo_rgb_color_ukr.svg";
import KgcLogo from "@/components/Footer/icons/logo_kgc.svg";
import GfuLogo from "@/components/Footer/icons/logo_gfu.svg";
import MspLogoWhite from "@/components/Footer/icons/MSP_logo_white.svg";
import KgcLogoWhite from "@/components/Footer/icons/logo_kgc_white.svg";
import GfuLogoWhite from "@/components/Footer/icons/gfu_logo_white.svg";
import {useStore} from "@/store/useStore";

export const AppFooter = () => {
    const useIncreasedContrastTheme = useStore((state) => state.useIncreasedContrastTheme);
    const isMobile = useStore((state) => state.isMobile);
    const mainBackgroundColor = useIncreasedContrastTheme ? `var(--main-color-black)` : `var(--second-color-grey)`;
    const mainTextColor = useIncreasedContrastTheme ? `var(--main-color-white)` : `var(--main-color-black)`;
    return (
        <Row>
            <Col flex="auto">
                <PageContainer height={`179px`} mainBackgroundColor={mainBackgroundColor}>
                    <Row align="middle" justify="space-between" gutter={[16, 16]}>
                        <Col>
                            <Row style={{fontSize: "18px", color: useIncreasedContrastTheme ? "#FFFFFF80" : "#192F51", marginBottom:"30px"}}>Створено за підтримки</Row>
                            <Row gutter={isMobile ? [16, 16] : 32} style={{minWidth: 0}}>
                                <Col>
                                    <img style={{ minWidth: 100 }} src={useIncreasedContrastTheme ? MspLogoWhite : MspLogo} alt={'MspLogo'} />
                                </Col>
                                <Col>
                                    <img style={{ minWidth: 100 }} src={useIncreasedContrastTheme ? GfuLogoWhite : GfuLogo} alt={'GfuLogo'} />
                                </Col>
                                <Col><img style={{ minWidth: 100 }} src={useIncreasedContrastTheme ? KgcLogoWhite : KgcLogo} alt={'KgcLogo'} /></Col>
                            </Row>
                        </Col>
                        <Col>
                            <span style={{fontSize: "18px", fontWeight: 500, color: mainTextColor}}>Всі права захищені © {new Date().getFullYear()}</span>
                        </Col>
                    </Row>
                </PageContainer>
            </Col>
        </Row>
    );
}